import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-insufficient-balance',
  standalone: false,
  templateUrl: './modal-insufficient-balance.component.html',
  styleUrl: './modal-insufficient-balance.component.scss'
})
export class ModalInsufficientBalanceComponent {
  @Input() isVisible: boolean = false;
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  handleCancel() {
    this.cancel.emit();
  }

  handleConfirm() {
    this.confirm.emit();
  }
}
